/** Only these parent fields are required for bulk upload */
export const REQUIRED_PARENT_HEADERS = [
  'Parent First Name',
  'Parent Last Name',
  'Parent Email',
  'Parent Primary Phone',
] as const;

/** Sentinel value for "column value not provided" in non-required fields */
export const NOT_PROVIDED = '__NOT_PROVIDED__';

export const PARENT_REGISTRATION_CSV_HEADERS = [
  'Parent First Name',
  'Parent Last Name',
  'Parent Email',
  'Parent Primary Phone',
  'Relation',

  'Address Apartment',
  'Address City',
  'Address Country',
  'Address State',
  'Address Street',
  'Address Zip',

  'Emergency Contact 1 First Name',
  'Emergency Contact 1 Last Name',
  'Emergency Contact 1 Primary Phone',
  'Emergency Contact 1 Email',
  'Emergency Contact 1 Authorize Pickup',

  // Student 1 (Required)
  'Student 1 First Name',
  'Student 1 Last Name',
  'Student 1 Date of Birth',
  'Student 1 Gender',
  'Student 1 Email',
  'Student 1 Primary Phone',
  'Student 1 Costume Size',
  'Student 1 Transportation',
  'Student 1 Health Insurance Carrier',
  'Student 1 Primary Doctor',
  'Student 1 Allergies',
  'Student 1 Disabilities',
  'Student 1 Medications',
  'Student 1 Special Needs',

  // Student 2 (Optional)
  'Student 2 First Name',
  'Student 2 Last Name',
  'Student 2 Date of Birth',
  'Student 2 Gender',
  'Student 2 Email',
  'Student 2 Primary Phone',
  'Student 2 Costume Size',
  'Student 2 Transportation',
  'Student 2 Health Insurance Carrier',
  'Student 2 Primary Doctor',
  'Student 2 Allergies',
  'Student 2 Disabilities',
  'Student 2 Medications',
  'Student 2 Special Needs',

  // Student 3 (Optional)
  'Student 3 First Name',
  'Student 3 Last Name',
  'Student 3 Date of Birth',
  'Student 3 Gender',
  'Student 3 Email',
  'Student 3 Primary Phone',
  'Student 3 Costume Size',
  'Student 3 Transportation',
  'Student 3 Health Insurance Carrier',
  'Student 3 Primary Doctor',
  'Student 3 Allergies',
  'Student 3 Disabilities',
  'Student 3 Medications',
  'Student 3 Special Needs',

  // Student 4 (Optional)
  'Student 4 First Name',
  'Student 4 Last Name',
  'Student 4 Date of Birth',
  'Student 4 Gender',
  'Student 4 Email',
  'Student 4 Primary Phone',
  'Student 4 Costume Size',
  'Student 4 Transportation',
  'Student 4 Health Insurance Carrier',
  'Student 4 Primary Doctor',
  'Student 4 Allergies',
  'Student 4 Disabilities',
  'Student 4 Medications',
  'Student 4 Special Needs',

  // Student 5 (Optional)
  'Student 5 First Name',
  'Student 5 Last Name',
  'Student 5 Date of Birth',
  'Student 5 Gender',
  'Student 5 Email',
  'Student 5 Primary Phone',
  'Student 5 Costume Size',
  'Student 5 Transportation',
  'Student 5 Health Insurance Carrier',
  'Student 5 Primary Doctor',
  'Student 5 Allergies',
  'Student 5 Disabilities',
  'Student 5 Medications',
  'Student 5 Special Needs',
] as const;

export type ParentRegistrationCSVHeader =
  (typeof PARENT_REGISTRATION_CSV_HEADERS)[number];

export interface ParentRegistrationColumnMappingTableData {
  header: string;
  sample: string;
  selectedColumn: string;
  columnValue: string | number | undefined;
}
